import { Routes } from '@angular/router';

import { RouteType } from './business/route-type.enum';
import { ErrorComponent } from './components/error/error.component';
import { SelectorContractComponent } from './components/selector/contract/selector-contract.component';
import { SelectorUsageComponent } from './components/selector/usage/selector-usage.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AuthGuard } from './guards/auth.guard';

export const EcmRouterRoutes: Routes = [
    {
        path: 'identification',
        component: UnauthorizedComponent,
        data: {
            type: RouteType.VISITOR,
        },
    },
    {
        path: 'indisponible',
        component: ErrorComponent,
        data: {
            i18n: 'default',
            type: RouteType.VISITOR,
        },
    },
    {
        path: 'service-indisponible',
        component: ErrorComponent,
        data: {
            i18n: 'custom',
            type: RouteType.VISITOR,
        },
    },
    {
        // Usage selector
        path: 'selectionner-un-usage',
        component: SelectorUsageComponent,
        canActivate: [AuthGuard],
    },
    {
        // Contract selector
        path: 'selectionner-un-contrat',
        component: SelectorContractComponent,
        canActivate: [AuthGuard],
    },
    {
        path: '**',
        component: ErrorComponent,
        data: {
            i18n: 'not-found',
            type: RouteType.VISITOR,
        },
    },
];
